import { Stack, Typography } from "@mui/material";
import DefaultDialog from "../../../Common/components/DefaultDialog";
import { useTranslation } from "react-i18next";

interface MedicalConsultationPartnerMoreInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MedicalConsultationPartnerMoreInfoModal({
  isOpen,
  onClose,
}: MedicalConsultationPartnerMoreInfoModalProps) {
  const { t } = useTranslation();

  return (
    <DefaultDialog
      label={t("MedicalConsultationPartner.more.info.modal.title")}
      isOpen={isOpen}
      onClose={onClose}
      fullWidth={true}
      paperStyleProps={{
        p: 2,
      }}
    >
      <Stack pt={3} spacing={2}>
        <Typography variant="h3" fontWeight={600} align="center">
          {t("MedicalConsultationPartner.more.info.modal.title")}
        </Typography>
        <Stack spacing={2}>
          <>
            {(
              t<any, any, string[]>(
                "MedicalConsultationPartner.more.info.modal.body",
                {
                  returnObjects: true,
                }
              ) as []
            ).map((text: string, index: number) => (
              <Stack
                direction="row"
                textAlign="center"
                spacing={1}
                key={String(text + index)}
              >
                <Typography variant="body1" color="neutral">
                  {text}
                </Typography>
              </Stack>
            ))}
          </>
        </Stack>
      </Stack>
    </DefaultDialog>
  );
}
